import React, { Component } from 'react';
import { Route, Switch as Routes } from 'react-router-dom';
import withAlert from '../../components/withAlert';
import Customer from '../customer/CustomerForm.js';
import CustomerIndex from '../customer/CustomerIndex';
import PartnerForm from '../wlpartner/PartnerForm.jsx';
import PartnerIndex from '../wlpartner/PartnerIndex.jsx';
import Index from './Index';
import Module from '../module/Module';
import ModuleIndex from '../module/ModuleIndex';
import Term from '../term/Term';
import TermIndex from '../term/TermIndex';
import User from '../user/User';
import Users from '../user/UserIndex';
import PlanIndex from '../plan/PlanIndex';
import Voucher from '../voucher/Voucher';
import Norm from '../norm/Norm';
import NormIndex from '../norm/NormIndex';
import Requisite from '../requisite/Requisite';
import RequisiteIndex from '../requisite/RequisiteIndex';
import BoardModelndex from '../boardModel/BoardModelndex';
import TutorialVideoslndex from '../tutorialVideos/TutorialVideosIndex';

const RouterMain = () => {
  return (
    <Routes>
      <Route exact path="/" children={withAlert(Index)} />
      <Route exact path="/Customer" children={withAlert(CustomerIndex)} />
      <Route exact path="/Partner" children={withAlert(PartnerIndex)} />
      <Route exact path="/Module" children={withAlert(ModuleIndex)} />
      <Route exact path="/User" children={withAlert(Users)} />
      <Route exact path="/User/Create" children={withAlert(User)} />
      <Route exact path="/Customer/Create" children={withAlert(Customer)} />
      <Route exact path="/Partner/Create" children={withAlert(PartnerForm)} />
      <Route exact path="/Partner/Update/:nWlpnId" children={withAlert(PartnerForm)} />
      <Route exact path="/Module/Create" children={withAlert(Module)} />
      <Route exact path="/Module/Update/:nModuleId" children={withAlert(Module)} />
      <Route exact path="/Term" children={withAlert(TermIndex)} />
      <Route exact path="/Term/Create" children={withAlert(Term)} />
      <Route exact path="/Term/Update/:nAdctId" children={withAlert(Term)} />
      <Route exact path="/Norm" children={withAlert(NormIndex)} />
      <Route exact path="/Norm/Create" children={withAlert(Norm)} />
      <Route exact path="/Norm/Update/:nNormId" children={withAlert(Norm)} />
      <Route exact path="/Plan" children={withAlert(PlanIndex)} />
      <Route exact path="/Voucher/Create" children={withAlert(Voucher)} />
      <Route exact path="/Requisite/:nNormId" children={withAlert(RequisiteIndex)} />
      <Route exact path="/Requisite/Create" children={withAlert(Requisite)} />
      <Route exact path="/Requisite/Update/:nRequisiteId" children={withAlert(Requisite)} />
      <Route exact path="/board-models" children={withAlert(BoardModelndex)} />
      <Route exact path="/tutorial-videos" children={withAlert(TutorialVideoslndex)} />
    </Routes>
  );
}

export default RouterMain;
